import React from "react";
import BackToHomeHeader from "../components/common/BackToHomeHeader";
import { IntroSection, AboutText, MainSections } from "../components/pages/salary/SalarySections";
import { NextProjectFooter } from "../components/common/Footer";

const SalaryPage = () => ([
	<BackToHomeHeader key="header" title="Salary" company="LinkedIn" />,
	<IntroSection key="intro" />,
	<AboutText key="about" />,
	<MainSections key="main" />,
	<NextProjectFooter key="next" href="/lookup" />,
]);

export default SalaryPage;


// WEBPACK FOOTER //
// ./src/pages/salary.js